
export const showInfoNotification = (message: string, timeout = 4000) => {
  const toast = useToast();
  toast.add({
    description: message,
    timeout,
    icon: "i-tabler-info-circle"
  });
};

export const showSuccessNotification = (message: string, timeout = 4000) => {
  const toast = useToast();
  toast.add({
    description: message,
    timeout,
    icon: "i-tabler-circle-check"
  });
};

// oRPC rate-limit interceptor toasts itself; skip follow-up error toasts in the same turn.
let suppressErrorToast = 0;

export const suppressErrorNotification = () => {
  const gen = ++suppressErrorToast;
  setTimeout(() => {
    if (gen === suppressErrorToast) suppressErrorToast = 0;
  });
};

export const showErrorNotification = (message: string, timeout = 10000) => {
  if (suppressErrorToast) return;
  const toast = useToast();
  toast.add({
    description: message,
    timeout,
    ui: {
      background: "bg-red-700",
      description: "text-white",
      title: "text-white",
      closeButton: { color: "white" }
    },
    icon: "i-tabler-circle-x"
  });
};
